import moment from "moment";

export function ConvertDateTime(date: string, format = '') {
    let datetime = null;
    if(date) datetime = moment(date).format(format);
    if(datetime) return datetime;
    return false;
}
